var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from 'react';
import { getCurrentProvider } from '../Async/MedicationsSummaryAsync';
import { useMedicationSettings } from '../Config/MedicationConfig';
import { useAsync, UseAsyncStatus } from '../Hooks/useAsync';
import { usePermissions } from '../Hooks/usePermissions';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { AlertBanner, AlertBannerTypes } from './AlertBanner';
import { ButtonSize } from './Button';
import styles from './PrescriberDetailsWarning.module.css';
var Link = function (_a) {
    var text = _a.text, permission = _a.permission, testId = _a.testId, routeFunc = _a.routeFunc, routeLink = _a.routeLink, openInNewWindow = _a.openInNewWindow;
    var permissions = usePermissions({
        hasPermission: permission
    });
    if (routeLink && permissions.hasPermission)
        return (React.createElement("a", { className: styles.warningLink, href: routeLink, target: openInNewWindow ? '_blank' : '_self', "data-test-id": "link_" + testId, rel: 'noreferrer' }, text));
    if (routeFunc && permissions.hasPermission)
        return (React.createElement("a", { className: styles.warningLink, onClick: routeFunc, "data-test-id": "link_" + testId }, text));
    return React.createElement(React.Fragment, null, text);
};
function isValidProviderPrescriber(prescriberDetails) {
    var _a;
    var validPrescriberNumber = false;
    if (prescriberDetails.number) {
        validPrescriberNumber = ((_a = prescriberDetails.number) === null || _a === void 0 ? void 0 : _a.trim().length) > 0;
    }
    return prescriberDetails.activePrescriber && prescriberDetails.pbsPrescriberGroup != null && validPrescriberNumber;
}
var WarningMessage = function (props) {
    return (React.createElement("span", null,
        props.message[0],
        React.createElement(Link, { text: props.message[1], permission: props.permission, testId: props.testId, routeLink: props.getProviderRoute
                ? props.getProviderRoute(props.currentProvider ? props.currentProvider : null)
                : undefined, routeFunc: props.onClick
                ? function () { return props.onClick && props.onClick(props.currentProvider ? props.currentProvider : null); }
                : undefined, openInNewWindow: true }),
        props.message[2]));
};
export var PrescriberDetailsWarning = function (props) {
    var _a;
    var httpConfig = useHttpConfig();
    var message;
    var currentProvider = null;
    var medicationSettings = useMedicationSettings();
    var providersAreLinkedToUserAccounts = medicationSettings.settings.providersAreLinkedToUserAccounts;
    var providerAsync = useAsync({
        defaultValue: null,
        httpConfig: httpConfig,
        getApi: getCurrentProvider
    });
    function retreiveCurrentProvider() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    providerAsync.getApi(props.serviceAuthorisationSystem, props.serviceAuthorisationSystemForeignKey);
                }
                catch (e) {
                    console.error('Error retrieving current provider: ', e);
                    currentProvider = null;
                }
                return [2 /*return*/];
            });
        });
    }
    useEffect(function () {
        retreiveCurrentProvider();
    }, []);
    currentProvider = providerAsync.data;
    if (currentProvider) {
        if (((_a = currentProvider.prescriberDetails) === null || _a === void 0 ? void 0 : _a.activePrescriber) &&
            !isValidProviderPrescriber(currentProvider.prescriberDetails)) {
            message = (React.createElement(WarningMessage, { message: [
                    "Your prescriber details aren't valid. Before you can generate a script, you must ",
                    "update your prescriber details",
                    " for the current provider."
                ], permission: MedicationsPermissions.WriteStaffMembers, testId: 'provider', currentProvider: currentProvider, getProviderRoute: props.getProviderRoute }));
        }
        else {
            if (!currentProvider.healthProviderIdentifierForIndividuals) {
                message = (React.createElement(WarningMessage, { message: [
                        "A Healthcare Provider Identifier - Individual (HPI-I) does not exist for this user. ",
                        "Add or update your HPI-I",
                        "."
                    ], permission: MedicationsPermissions.WriteStaffMembers, testId: 'hpii', currentProvider: currentProvider, getProviderRoute: props.getProviderRoute }));
            }
        }
    }
    else {
        if (providersAreLinkedToUserAccounts) {
            message = (React.createElement(WarningMessage, { message: [
                    "Your provider details aren't valid. Before you can generate a script, you must ",
                    "assign your username to a provider",
                    "."
                ], permission: MedicationsPermissions.WriteStaffMembers, testId: 'provider', getProviderRoute: props.getProviderRoute }));
        }
        else {
            message = (React.createElement(WarningMessage, { message: [
                    "Your provider details aren't valid. Before you can generate a script, you must ",
                    "assign a provider to the service",
                    "."
                ], permission: MedicationsPermissions.EncounterPerform, testId: 'service', onClick: props.goToEncounterFinaliseRoute }));
        }
    }
    var showAlert = props.showWarning &&
        !!message &&
        providerAsync.loadCount !== 0 &&
        providerAsync.status === UseAsyncStatus.Loaded;
    return showAlert ? (React.createElement(AlertBanner, { lowerHeight: true, verticalSpace: true, infoLine: message, buttonSize: ButtonSize.small, promptType: AlertBannerTypes.Warn, noBorder: true, onDismissAlert: props.onShowWarningClose })) : null;
};
